import type { ReactNode } from 'react';

const btn = 'px-3 py-1.5 rounded text-sm font-medium disabled:opacity-40';

/** Accessible modal following the client's modal convention (Enter = action, Escape = Cancel). */
export function Dialog({ title, children, onCancel, onConfirm, confirm, busy, danger }: {
  title: string; children: ReactNode; onCancel: () => void; onConfirm?: () => void; confirm?: string; busy?: boolean; danger?: boolean;
}) {
  return (
    <div data-management-modal role="dialog" aria-modal="true" aria-labelledby="dialog-title" className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 border border-gray-600 rounded-lg w-full max-w-lg p-5 space-y-4 max-h-[90vh] overflow-y-auto">
        <h3 id="dialog-title" className="text-lg font-semibold">{title}</h3>
        <div className="text-sm space-y-2">{children}</div>
        <div className="flex justify-end gap-2">
          <button type="button" className={`${btn} bg-gray-700 hover:bg-gray-600`} onClick={onCancel} disabled={busy}>Cancel</button>
          {onConfirm && confirm && (
            <button type="submit" autoFocus className={`${btn} ${danger ? 'bg-red-700 hover:bg-red-600' : 'bg-blue-600 hover:bg-blue-500'}`} onClick={onConfirm} disabled={busy}>
              {busy ? 'Working…' : confirm}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
